import { useState } from 'react'

import { useToast } from '@/hooks'
import { useFilingMutations } from '@/modules/tools/bankruptcy/hooks'
import type {
  CaseDocument,
  Filing,
} from '@/modules/tools/bankruptcy/stores/types'
import { type PresignedBlob, UploadForm } from '@/modules/upload'
import { DocumentsPanel } from './DocumentsPanel'

interface DocumentsManagerProps {
  filing: Filing
  documents: CaseDocument[]
}

export const DocumentsManager = ({
  filing,
  documents,
}: DocumentsManagerProps) => {
  const { attachDocuments } = useFilingMutations()
  const { successToast } = useToast()
  const [attachError, setAttachError] = useState<string | null>(null)

  const handleAttach = (blobs: PresignedBlob[]) => {
    const blobsIds = blobs.map(({ signed_id }) => signed_id)
    if (blobsIds.length === 0) return

    setAttachError(null)
    attachDocuments(filing.id, blobsIds)
      .then(() => successToast('Documents added'))
      .catch((error) =>
        setAttachError(
          error instanceof Error ? error.message : 'Failed to add documents.',
        ),
      )
  }

  return (
    <div className="space-y-4">
      <DocumentsPanel filingId={filing.id} documents={documents} />

      {attachError && (
        <p className="rounded-lg border border-red-200 bg-red-50 p-3 text-red-700 text-sm">
          {attachError}
        </p>
      )}

      <div className="rounded-lg border bg-white p-3">
        <UploadForm
          onSubmit={handleAttach}
          disabled={filing.atPageLimit}
          collapsed={documents.length > 0}
          pageWideDrop
        />
      </div>
    </div>
  )
}
